import React from 'react';
import cx from 'classnames';
import { omit } from 'lodash';

const Breathing = (props) => {
  const {
    children,
    componentClass,
    className,
    active = false,
    duration = 2,
    ...childProps
  } = props;
  const Component = componentClass || 'div';

  return (
    <Component
      {...childProps}
      className={cx(className, { [`breathing-${duration}`]: active })}
    >
      {children}
    </Component>
  );
};

export default Breathing;
